angular.module('rentalListingModule').component('rentalListingGeneralInfo', {
	templateUrl: 'rentalListingGeneralInfo/rentalListingGeneralInfo.html',
	bindings: {
		form: '<',
		listing: '<',
		user: '<',
		filters: '<',
		isMobile: '<',
		isLoggedIn: '<',
		errorMessages: '<',
		emailUsRpc: '<',
		buildingSearchRpc: '<',
		brokerSearchRpc: '<',
		companyPhone: '<',
		unitList: '<',
		maxPrice: '<',
		minPrice: '<',
		maxSqft: '<',
		minSqft: '<',
		onUpdateUnitList: '&',
		activeStep: '<',
		steps: '<'
	},
	controller: ['$http', 'PubSub', 'rentalListingVariables', function($http, PubSub, rentalListingVariables) {
		var ctrl = this;
		this.rentalListingVariables = rentalListingVariables;
		this.onBuildingSearch = false;
		this.onUnitSearch = false;
		this.placeholderBuilding = 'add by street or building name';
		this.placeholderUnit = 'e.g. 3B';
		this.placeholderSqft = 'e.g. 1,250';
		this.placeholderPrice = 'e.g. $2,800';
		this.placeholderDescription = 'enter a short description';
		this.placeholderAgent= 'your agent\'s name';
		this.listing.listing_amenities_flag = this.listing.listing_amenities_flag || {};

		this.setBedrooms= function(option) {
			this.listing.beds = option.value;
			this.listing.bedsLabel = option.label;
		}

		this.setBathrooms= function(option) {
			this.listing.baths = option.value;
			this.listing.bathsLabel = option.label;
		}

		this.setFreeRent= function(option) {
			this.listing.freeRent = option.value;
			this.listing.freeRentLabel = option.label;
		}

		this.setExclusiveToAgent = function() {
			this.listing.exclusiveToAgent = !this.listing.exclusiveToAgent;
			if (!this.listing.exclusiveToAgent) {
				this.listing.agent = null;
				this.listing.agentLabel = null;
			}
		};

		this.selectBuilding = function(building) {
			var unitList = building.units || [];

			this.onUpdateUnitList({list: unitList});

			if (building.hoodName) {
				this.listing.buildingHood = building.hoodName;
			}

			// if user selects another building and listing unit already exist in the field,
			// we should reset the listing unit
			if (this.listing.unit) {
				this.listing.unit = null;
				this.listing.unitLabel = null;

				PubSub.publish('updateLimousineQueryByModel-unit');
			}
		}

		this.buildingSearch = function() {
			this.onBuildingSearch = true;
		};

		this.unitSearch = function() {
			this.onUnitSearch = true;
			PubSub.publish('rental-listing-hide-unit-exist');
		};

		this.closedBuildingSearch = function() {
			this.onBuildingSearch = false;

			// reset unit when the user deleted the previous selected building
			if (!this.listing.building && this.listing.unit) {
				this.listing.unit = null;
				this.listing.unitLabel = null;

				PubSub.publish('updateLimousineQueryByModel-unit');
			}
		};

		this.closedUnitSearch = function() {
			this.onUnitSearch = false;
		};

		this.click = function(event) {
			if (!angular.element(event.target).hasClass('unit') && !angular.element(event.target).parent().hasClass('unit')) {
				PubSub.publish('closeLimousine-unit');
			}
		};

		this.showUnitExistError = function() {
			if (ctrl.form && ctrl.form.unit) {
				ctrl.form.unit.$setValidity('unitExist', false);
				ctrl.form.unit.$setTouched();
			}
		}

		this.hideUnitExistError = function() {
			if (ctrl.form && ctrl.form.unit) {
				ctrl.form.unit.$setValidity('unitExist', true);
				ctrl.form.unit.$setUntouched();
			}
		}

		PubSub.subscribe('rental-listing-show-unit-exist', this.showUnitExistError);
		PubSub.subscribe('rental-listing-hide-unit-exist', this.hideUnitExistError);
	}]
});
